var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-contactFormFile" },
    [
      _c(
        "div",
        {
          staticClass: "o-fieldsgrid",
          on: {
            dragover: function($event) {
              $event.preventDefault()
            },
            drop: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "o-input o-fieldsgrid__field o-fieldsgrid__field--half"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fromName,
                    expression: "fromName"
                  }
                ],
                staticClass: "w-full validate input",
                class: { valid: _vm.fromName },
                attrs: {
                  type: "text",
                  id: "fromName",
                  name: "fromName",
                  required: "required"
                },
                domProps: { value: _vm.fromName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.fromName = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "fromName" } }, [
                _vm._v(" " + _vm._s(_vm.translations["Name of contact"]) + "* ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "o-input o-fieldsgrid__field o-fieldsgrid__field--half"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.company,
                    expression: "company"
                  }
                ],
                staticClass: "w-full validate input",
                class: { valid: _vm.company },
                attrs: {
                  type: "text",
                  id: "contactCompany",
                  name: "message['company']",
                  required: "required"
                },
                domProps: { value: _vm.company },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.company = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "contactCompany" } }, [
                _vm._v(" " + _vm._s(_vm.translations["Company"]) + "* ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "o-input o-fieldsgrid__field o-fieldsgrid__field--half"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fromEmail,
                    expression: "fromEmail"
                  }
                ],
                staticClass: "w-full validate input",
                class: { valid: _vm.fromEmail },
                attrs: {
                  type: "text",
                  id: "contactEmail",
                  name: "fromEmail",
                  required: "required"
                },
                domProps: { value: _vm.fromEmail },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.fromEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "contactEmail" } }, [
                _vm._v(" " + _vm._s(_vm.translations["E-mail"]) + "* ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "o-input o-fieldsgrid__field o-fieldsgrid__field--half"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone"
                  }
                ],
                staticClass: "w-full validate input",
                class: { valid: _vm.phone },
                attrs: {
                  type: "text",
                  id: "contactphone",
                  name: "phone",
                  required: "required"
                },
                domProps: { value: _vm.phone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.phone = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "contactphone" } }, [
                _vm._v(" " + _vm._s(_vm.translations["Phone"]) + "* ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "o-input o-fieldsgrid__field o-fieldsgrid__field--full"
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.message,
                    expression: "message"
                  }
                ],
                class: { valid: _vm.message },
                attrs: {
                  rows: "10",
                  cols: "40",
                  id: "message",
                  name: "message[comment]"
                },
                domProps: { value: _vm.message },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.message = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "message" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.translations["Comment"]) +
                    "\n        "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-contactFormFile__uploads",
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.addFiles()
                },
                drop: _vm.dropFiles
              }
            },
            [
              _c("input", {
                ref: "files",
                attrs: { multiple: "", type: "file", id: "file" },
                on: {
                  change: function($event) {
                    return _vm.handleFileUpload($event)
                  }
                }
              }),
              _vm._v(" "),
              !_vm.files.length
                ? _c(
                    "div",
                    { staticClass: "c-contactFormFile__uploads-empty" },
                    [
                      _c("plus-icon"),
                      _vm._v(
                        "\n        Click to upload relevant pictures, drawings or documents\n        "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-contactFormFile__uploads-files__container" },
                _vm._l(_vm.files, function(file, key) {
                  return _c(
                    "div",
                    {
                      key: file.index,
                      staticClass: "file c-contactFormFile__uploads-files"
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(file.name) + "\n            "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "remove-file",
                          on: {
                            click: function($event) {
                              return _vm.removeFile(key)
                            }
                          }
                        },
                        [_c("plus-icon")],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { position: "fixed", left: "-100%", top: "-100%" },
          attrs: { tabindex: "-1", "aria-hidden": "true" }
        },
        [
          _c("label", {
            attrs: {
              for: "50d642e8-add6-4cd0-aa23-0341da07a60c",
              "aria-hidden": "true",
              tabindex: "-1"
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form_company,
                expression: "form_company"
              }
            ],
            attrs: {
              type: "text",
              name: "form_company",
              value: "",
              id: "50d642e8-add6-4cd0-aa23-0341da07a60c",
              tabindex: "-1",
              "aria-hidden": "true"
            },
            domProps: { value: _vm.form_company },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.form_company = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-contactFormFile__submit" }, [
        _c(
          "div",
          {
            staticClass: "o-btn o-btn--button",
            on: {
              click: function($event) {
                return _vm.submitForm()
              }
            }
          },
          [
            _c("div", { staticClass: "button" }, [_c("chevron-icon")], 1),
            _vm._v(
              "\n        " + _vm._s(_vm.translations["Submit"]) + "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isSubmitting
          ? _c(
              "div",
              { staticClass: "c-contactFormFile__loader" },
              [
                !_vm.success ? _vm._t("loader") : _vm._e(),
                _vm._v(" "),
                _vm.success ? _vm._t("success") : _vm._e()
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }